import React from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import PrimaryButton from './PrimaryButton';
import logo from '../assets/rounded_logo.svg';
import axiosClient from '../services/axiosClient';

const features = [
  "Post listing on major platforms",
  "AI agent handles all inquiries.",
  "AI pre-screens prospects",
  "AI delivers high quality leads",
  "AI schedules all tours.",
];

interface CheckoutContentProps {
  source: string;
  onError: () => void;
  onClose: () => void;
  listingId?: string;
}

const CheckoutContent: React.FC<CheckoutContentProps> = ({ source, onError, onClose, listingId }) => (
  <>
    {/* Title */}
    <Typography variant="h6" fontWeight="bold" sx={{ px: 3, pt: 3 }}>
      You relax. We&apos;ll handle the rest.
    </Typography>

    {/* Cost breakdown */}
    <Box
      sx={{
        background: '#fafafa',
        borderRadius: 2,
        border: '1px solid #eee',
        mx: 3,
        my: 2,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <Typography fontWeight={600} mb={1}>Cost breakdown:</Typography>
      <Box display="flex" alignItems="baseline">
        <Typography variant="h4" fontWeight="bold" mr={1}>$15</Typography>
        <Typography variant="body1" color="text.secondary">/ listing</Typography>
      </Box>
      <Typography variant="body1" color="text.secondary">One time payment</Typography>
      <Typography variant="body1" color="text.secondary">Active for 3 months</Typography>
    </Box>

    {/* Features */}
    <Box sx={{ px: 3, pb: 2 }}>
      {features.map((feature, idx) => (
        <Box key={idx} display="flex" alignItems="flex-start" mb={1}>
          <CheckIcon sx={{ color: 'black', fontSize: 20, mt: '2px', mr: 1 }} />
          <Typography variant="body2">{feature}</Typography>
        </Box>
      ))}
    </Box>

    {/* CTA Button */}
    <Box sx={{ px: 3, pb: 3, mt: 1 }}>
      <PrimaryButton
        fullWidth
        sx={{
          fontWeight: 600,
          fontSize: 16,
          py: 1.5,
          borderRadius: '30px',
        }}
        onClick={async () => {
          try {
            const response = await axiosClient.post('/payments/create_checkout_session', {
              source,
              listingId
            });
            window.open(response.data.url, '_blank', 'noopener,noreferrer');
            // Close the overlay after the user clicks the button
            onClose();
          } catch (error) {
            console.error('Error creating checkout session:', error);
            onError();
          }
        }}
      >
        Proceed to checkout
      </PrimaryButton>
    </Box>
  </>
);

export default CheckoutContent;